import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { bookingItem, business, navItems } from '../data/site';
export function SiteFooter() {
  return <footer className="border-t border-white/10 bg-ink text-white" data-id="element-160" data-mp="3mh9hm6lmehfi">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 md:grid-cols-[1.4fr_1fr_1fr]" data-id="element-161" data-mp="3mfg90lrg5n4v">
        <div data-id="element-162" data-mp="3hgddbrxcwt9k">
          <Logo data-id="element-163" data-mp="3dguud1p3is9d" />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-fog" data-id="element-164" data-mp="3dgl031x0pyxv">
            Spécialiste du nettoyage de véhicules à la vapeur, à domicile, dans le sud de la Somme depuis {business.since}. Anciennement {business.formerName}.
          </p>
        </div>
        <nav aria-label="Pied de page" data-id="element-165" data-mp="33krhb0sph97n">
          <h2 className="text-sm font-semibold text-white" data-id="element-166" data-mp="2yk3rgig7qyf0">Le site</h2>
          <ul className="mt-4 grid grid-cols-2 gap-x-6 gap-y-2.5 text-sm" data-id="element-167" data-mp="2ylyga7ulvaod">
            {[...navItems, bookingItem].map(item => <li key={item.to} data-id="element-168" data-mp="wrpabllhtxzn">
                <Link to={item.to} className="text-fog transition-colors duration-150 ease-out hover:text-lime" data-id="element-169" data-mp="wsqnbvm2kuk0">
                  {item.label}
                </Link>
              </li>)}
          </ul>
        </nav>
        <div data-id="element-170" data-mp="1anlnvm57zd03">
          <h2 className="text-sm font-semibold text-white" data-id="element-171" data-mp="vspakuijzzg5">Contact</h2>
          <address className="mt-4 space-y-2.5 text-sm not-italic text-fog" data-id="element-172" data-mp="vuij6fcq8tqs">
            <p data-id="element-173" data-mp="10sk1uz68qr1q">
              {business.addressLine1}, {business.addressLine2}
            </p>
            <p data-id="element-174" data-mp="1oio0es4ko0lv">
              <a href={business.phoneHref} className="text-white transition-colors duration-150 ease-out hover:text-lime" data-id="element-175" data-mp="1oi4uk9s752o7">
                {business.phone}
              </a>
            </p>
            <p data-id="element-176" data-mp="1er0fzb6fnjtw">Paiement : {business.payments.join(', ')}</p>
          </address>
        </div>
      </div>
      <div className="border-t border-white/10" data-id="element-177" data-mp="1jp1ztybonn6f">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-5 py-6 text-xs text-fog-dark sm:flex-row sm:justify-between sm:px-8" data-id="element-178" data-mp="27gh4hxqxmgku">
          <p data-id="element-179" data-mp="2c7pdwts9i1y0">© {new Date().getFullYear()} Kévin AutoVap. Tous droits réservés.</p>
          <p data-id="element-180" data-mp="2m364e0p3ivrr">Rogy · Somme (80)</p>
        </div>
      </div>
    </footer>;
}